/*
 * Digital diagnostics monitoring of the ONT gpon transcievers
 */
import { OntOpticalDdmInfo, OntOpticalDdmInfosBySerial } from "@ip6m/types";
import { Injectable, Logger } from "@nestjs/common";
import { HuaweiOidDB } from "../../core/services/huawei_oid.service";
import { SnmpService } from "../../core/services/snmp.service";
import { DeviceService } from "./device.service";

@Injectable()
export class DDMService {

    DDMs: OntOpticalDdmInfosBySerial = {};

    constructor(
        private deviceS: DeviceService, 
        private oidDB: HuaweiOidDB,
        private snmpService: SnmpService) {}

    get getAllDDMs(): OntOpticalDdmInfosBySerial {
        return this.DDMs;
    }

    async getData(ontSn: string, oltId: number = null): Promise<OntOpticalDdmInfo> {
        const oids = this.oidDB.hwGponDeviceOntOpticalDdmInfoTable()
        let numericOids = this.oidDB.getChildrenOids(oids);
        const ont = this.deviceS.getOnt(ontSn, oltId);
        numericOids = numericOids.map(oid => oid + '.' + ont.ifIndex + '.' + ont.ontId);

        const snmpOids = await this.snmpService.get(ont.oltId, numericOids).catch(error => {
            Logger.error('DDMService.getData error: ' + error);
        });

        if(snmpOids) {
            return {
                OpticalDdmTemperature: snmpOids[0].value,
                OpticalDdmBiasCurrent: snmpOids[1].value,
                OpticalDdmTxPower: snmpOids[2].value,
                OpticalDdmRxPower: snmpOids[3].value,
                OpticalDdmVoltage: snmpOids[4].value,
                OpticalDdmOltRxOntPower: snmpOids[5].value,
                OpticalDdmAniCATVRxPower: snmpOids[6].value
            }
        }
        
    }

    async getAllData(oltId: number) {
        const snList = Object.keys(this.deviceS.getOntsByOlt(oltId));
        for(let i=0; i<snList.length; i++) {
            const sn = snList[i];
            this.DDMs[sn] = await this.getData(sn, oltId);
            this.deviceS.setDdmData(oltId, sn, this.DDMs[sn]);
        }
    }

}